const ABStepCore = require("../core/ABStepCore");
module.exports = class ABStep extends ABStepCore {};
